;(function(w,d){
  // load UET base
  w.uetq = w.uetq||[];
  function initUET(){
    var cfg = {
      ti: "247010918",           // your UET Tag ID
      tm: "shpfy_ui",
      enableAutoSpaTracking: true
    };
    cfg.q = w.uetq;
    w.uetq = new UET(cfg);
    w.uetq.push("pageLoad");
    trackPurchase();
  }
  // inject UET script
  var s = d.createElement("script");
  s.src = "//bat.bing.com/bat.js";
  s.async = 1;
  s.onload = initUET;
  d.getElementsByTagName("script")[0].parentNode.insertBefore(s, d.getElementsByTagName("script")[0]);

  // look for Shopify order data and fire conversions
  function trackPurchase(){
    if(!w.Shopify || !Shopify.checkout) return;
    var o = Shopify.checkout;
    // hash email & phone
    var e = (o.email||"").toLowerCase().trim();
    var p = ((o.billing_address||o.shipping_address||{}).phone||"")
             .replace(/\D/g,"").trim();
    var em = CryptoJS.SHA256(e).toString();
    var ph = CryptoJS.SHA256(p).toString();

    w.uetq.push("set", { pid: { em: em, ph: ph } });
    // purchase event
    var ids = o.line_items.map(li=>li.product_id).join(",");
    w.uetq.push("event","PRODUCT_PURCHASE",{
      ecomm_prodid: ids,
      ecomm_pagetype: "PURCHASE",
      revenue_value: o.subtotal_price,
      currency: o.currency
    });
  }
})(window, document);
